module.exports = __webpack_public_path__ + "a52a899e7640d29da7026308aad7802c.pdf";